import { boardIdsBeingDeletedSelector } from '~/store/tasks/selectors';
import { useAirSelector } from '~/utils/ReduxUtils';

export const useBoardsBeingDeleted = () => {
  const boardIdsBeingDeleted = useAirSelector(boardIdsBeingDeletedSelector);

  return boardIdsBeingDeleted;
};
